import React from 'react';
export const defaultBoatData = {
    name: '',
    details: '',
    woodColor: '',
    interiorColor: '',
    hullColor: '',
    model: '',
    engine: '',
    image: ''
};